// extracted by mini-css-extract-plugin
module.exports = {"bkw-N":"N_bkw-N__LPTaI"};